import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState } from '../types';
import socketService from '../services/socketService';

const initialState: AuthState = {
    token: localStorage.getItem('token'),
    isAuthenticated: !!localStorage.getItem('token'),
    user: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess: (state, action: PayloadAction<{ token: string; user: { email: string; name?: string; slug?: string } }>) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.isAuthenticated = true;
            localStorage.setItem('token', action.payload.token);
        },
        logout: (state) => {
            state.token = null;
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem('token');

            // Disconnect Socket.io connection
            socketService.disconnect();

            // Clear user-specific localStorage items to prevent cross-user data leakage
            localStorage.removeItem('lastViewedMap');

            // Clear all map view settings from localStorage
            const keysToRemove = [];
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key && (key.startsWith('mapView_') || key === 'gatewayViewSettings')) {
                    keysToRemove.push(key);
                }
            }
            keysToRemove.forEach(key => localStorage.removeItem(key));
        },
    },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
